module.exports = __webpack_public_path__ + "static/media/logoSmall.16c03a6e.svg";